import * as React from "react";
import { Icon } from "../MemberShipProfile/common/Icon";
import { Button, Checkbox, Form, Input, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { LOGIN_SUCCESS } from "../../redux/auth/authType";
import { responseNotification } from "../../utils/notify";
import { debounce } from "lodash";

export const BusinessCreateForm: React.FC = () => {
  const { type, token } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [operationType, setOperationType] = useState<any>("INDIVIDUAL");
  const [businessType, setBusinessType] = useState<any>();
  const [companyId, setCompanyId] = useState<any>();
  const [isChecked, setIsChecked] = useState(false);
  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const [businessTypeOptions, setBusinessTypeOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [companyOptions, setCompanyOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const getBusinessTypeOptions = useCallback(async (key?: string) => {
    setBusinessTypeOptions({ loading: true, list: [] });
    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/shop/service-type-list?page=0&limit=20` +
        (key ? `&name=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setBusinessTypeOptions({
      loading: false,
      list: res?.data?.businessTypes?.map((business: any) => {
        return {
          value: business?.id,
          label: business?.name,
        };
      }),
    });
  }, []);
  const companyOption = useCallback(async (key?: string) => {
    setCompanyOptions({ loading: true, list: [] });
    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/shop/company-search?page=0&limit=20`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setCompanyOptions({
      loading: false,
      list: res?.data?.companies?.map((company) => {
        return {
          value: company?.id,
          label: company?.name,
        };
      }),
    });
  }, []);

  useEffect(() => {
    companyOption();
    getBusinessTypeOptions();
  }, [companyOption, getBusinessTypeOptions]);

  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      businessOperationType: operationType,
      businessTypeId: businessType,
      companyName: data.companyName,
    };
    await fetch(
      `${process.env.REACT_APP_RIDER_API}/merchant/choose-business-model`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...readyData }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 200) {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: {
              ...res,
              token: token,
              businessType:businessType,
              operationType:operationType,
              shopInfo: res?.shop,
              shopId: res?.shop?.id,
              iat: new Date(),
              type: res?.shop?.type || "JC_COMMERCE",
            },
          });
          responseNotification("Business Create Successfully", "success");
          form.resetFields();
          navigate("/business-create");
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };
  const fetchRef = useRef(0);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "businessType") getBusinessTypeOptions(value);
          if (field === "company") companyOption(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [getBusinessTypeOptions, companyOption, type]);

  return (
    <div className="flex overflow-hidden flex-col bg-stone-50 pb-[10px] max-md:pb-2">
      <main className="flex flex-col self-center mt-5 max-w-full font-bold w-[50%]">
        <div className="flex gap-2 self-start text-base text-zinc-800 pb-6">
          <h1>Create Business Model</h1>
        </div>
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          onFinish={onSubmit}
          form={form}
          layout="vertical"
          autoComplete="off"
        >
          <div className="w-full">
            <Form.Item
              hasFeedback
              label="Business Type"
              rules={[
                {
                  required: true,
                  message: "Business Type is required!",
                },
              ]}
              name="businessTypeId"
            >
              <Select
                showSearch
                placeholder="Select Business Type"
                optionFilterProp="children"
                onSearch={(val) => {
                  handleSearch(val, "businessType");
                }}
                onChange={(val) => setBusinessType(val)}
                filterOption={() => {
                  return true;
                }}
                options={businessTypeOptions?.list}
              ></Select>
            </Form.Item>
          </div>

          <div className="w-full">
            <Form.Item
              hasFeedback
              label="Business Operation Type"
              rules={[
                {
                  required: true,
                  message: "Business Operation Type is required!",
                },
              ]}
              name="businessOperationType"
            >
              <Select
                onChange={(val) => setOperationType(val)}
                options={[
                  {
                    value: "INDIVIDUAL",
                    label: "None, I am an Indusial (As a Person)",
                  },
                  {
                    value: "COMPANY",
                    label: "As a Company",
                  },
                ]}
                placeholder="Enter Operation Type"
              />
            </Form.Item>
          </div>

          {operationType === "COMPANY" && (
            <>
              {companyOptions?.length > 0 && (
                <>
                  <div className="">
                    <Form.Item
                      hasFeedback
                      label="Company Name"
                      rules={[
                        {
                          required: false,
                          message: "Company name is required!",
                        },
                      ]}
                      name="companyId"
                    >
                      <Select
                        showSearch
                        placeholder="Select Company name"
                        optionFilterProp="children"
                        onSearch={(val) => {
                          handleSearch(val, "company");
                        }}
                        onChange={(val) => setCompanyId(val)}
                        filterOption={() => {
                          return true;
                        }}
                        options={companyOptions?.list}
                      ></Select>
                    </Form.Item>
                  </div>
                  <Form.Item>
                    <Checkbox.Group>
                      <Row>
                        <Checkbox
                          value="newComapny"
                          checked={isChecked}
                          onChange={handleOnChange}
                        >
                          Add New Company
                        </Checkbox>
                      </Row>
                    </Checkbox.Group>
                  </Form.Item>
                  {isChecked && (
                    <div className="">
                      <Form.Item
                        hasFeedback
                        label="New Company Name"
                        name="companyName"
                      >
                        <Input
                          id="companyName"
                          type="text"
                          placeholder="Enter Company Name"
                        />
                      </Form.Item>
                    </div>
                  )}
                </>
              )}
              <div className="w-full">
                <Form.Item
                  hasFeedback
                  label="New Company Name"
                  name="companyName"
                >
                  <Input
                    id="companyName"
                    type="text"
                    placeholder="Enter Company Name"
                  />
                </Form.Item>
              </div>
            </>
          )}

          <div className="flex gap-3.5 self-center mt-8 mb-0 max-w-full text-center text-white whitespace-nowrap w-[212px] max-md:mb-2.5">

          <Button
            disabled={loading || !!error}
            loading={(loading ? "loading" : undefined) as any}
            type="primary"
            htmlType="submit"
            className="add-submit-btn text-center mr-2"
          >
            Submit
          </Button>

          <Button
            htmlType="button"
            onClick={() => {
              form?.resetFields();
            }}
            className="reset-submit-btn text-center mr-2"
          >
            Reset
          </Button>

          </div>
        </Form>
      </main>
    </div>
  );
};
export default BusinessCreateForm;
